import React from "react";
import Bundles from "src/pages/callrecorder/Bundles";
import ShowBundle from "src/pages/callrecorder/Bundles/Show";

const callrecorderRoutes = [
  { path: '/callrecorder/bundles',       element: <Bundles /> },
  { path: '/callrecorder/bundles/:id',   element: <ShowBundle /> },
]

export default callrecorderRoutes;
